<template>
    <div class="m-registerInfo">
        <vheader :collapsed="collapsed"  @show="toggleShow" @hide='toggleShow' :register="true" @showMail="showMail" ref="headers"/>
        <div class="m-section" :style="{ height: h, minHeight: h }" :class="{'bg': chooseStep || thisStep == 3.3 || thisStep == 3.2}">
            <el-scrollbar style="height: 100%;width: 100%;" wrapClass="scrollView" ref="conScroll">
                <!-- 步骤条 -->
                <steps :active="active" :step-list="stepList" :this-step="thisStep" />
                <!-- 第一步 选择园区 -->
                <frist-step :choose-ids="chooseIds"  v-if="chooseStep" @changeProject="changeProject" :is-register="true" :isChoose="true"/>
                <!-- 第二步 填写园区资料 -->
                <second-step  v-show="editStep" :park-List="parkList" ref="secondStep" :is-register="true" @goPark="prevStep"/>
                <!-- 第三步  提交审核 包括审核中 -->
                <third-step  v-if="thisStep > 0" ref="thirdStep" :this-step="thisStep" :check-remark="checkRemark"/>
            <!--  审核通过 资料通过 正常菜单界面--> 
                <!--  审核通过 资料不通过 有问题-->
                <!--  审核不通过 最后一步，重新编辑按钮-->
            </el-scrollbar>
        </div>
        <div class="foter-btns" v-if="!noFooter">
            <template v-if="thisStep == 0">
                <el-button class="btnNew" @click="prevStep" v-if="active > 1">上一步</el-button>
                <el-button class="btnNew" @click="nextStep" :disabled="parkList.length < 1 && chooseIds.length < 1" v-if="active < 3">下一步</el-button>
            </template>
            <template v-else>
                <!-- 3.3 审核驳回 -重新编辑 -->
                <el-button class="btnNew" @click="reEdit" v-if="thisStep == 3.3">重新编辑</el-button>
                <!-- 6  签约电子协议 -签约电子协议-->
                <el-button class="btnNew" @click="signUp" v-if="thisStep == 6">签约电子协议</el-button>
                <!-- 8  签约电子协议 -签约电子协议-->
                <el-button class="btnNew" @click="toRelease" v-if="thisStep == 8">发布服务</el-button>
            </template>
        </div>
        <!--消息列表-->
        <mail-side v-if='isMail' @hide="hideMail"></mail-side>
    </div>
</template>

<script>
import vheader from '@/components/vheader'
import mailSide from '@/components/mailSide'
import fristStep from '@/components/fristStep';
import secondStep from '@/views/setting/merchant/merchantUpt';
import thirdStep from '@/components/thirdStep';
import steps from '@/components/steps';
import { GetInfo } from '@/fetch/com'
import { stepLists, checkStatus } from '@/common/util/constans' 
import * as access from "@/config/access";
import API from '@/fetch/api';

export default {
    
    components: {
        vheader, mailSide, fristStep, steps, secondStep, thirdStep
    },
    data(){
        return {
            checkStatus,
            thisStep: 0,
            collapsed: false,
            isMail: false,
            chooseIds: [], //历史选中的数据
            active: 1,
            parkList: [],
            checkRemark: '',
            m_loading: null,
        }
    },
    computed: {
        stepList(){
            return this.thisStep < 4 ? stepLists.slice(0, 3) : stepLists.slice(3);
        },
        // 显示选择园区
        chooseStep(){
           return  this.active == 1 && this.thisStep == 0
        },
        // 显示编辑界面
        editStep(){
            return  this.active == 2 && this.thisStep == 0
        },
        noFooter(){
            return this.thisStep == 3.1 || this.thisStep == 4  || this.thisStep == 5 || this.thisStep == 7
        },
        h(){
            // this.thisStep == 3.1 不需要按钮
            let h = 0;
            h = this.editStep ? (70 + 80 + 40) : this.noFooter ? 120 : (this.thisStep == 6 || this.thisStep == 8) ? 190 : 230;
            /* if(this.thisStep == 2){
                h -= 20;
            } */
            return `${ document.documentElement.clientHeight - h }px`
        }
    },
    created(){
        this.checkLogin();
    },
    mounted(){
        this.queryUserInfo();
    },
    methods: {
        loading(){
            let vm = this;
            vm.m_loading = vm.$loading({
                lock: true,
                text: 'Loading',
                target: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        checkLogin(){
            let vm = this, token = GetInfo('token');
            if(!token) {
                vm.$showAlert('请先登录', 'error'); 
                vm.$router.push({ name: 'login'});
            }
        },
        queryUserInfo(){ // 查询用户基本信息 
            let vm = this;
            API.http({ url: '/merchant/audit_info', type: 'post'}).then(res => {
                if (res.code == 200) {
                    let userInfo = res.data;
                    /* 
                        几种情况：[
                        1选择入住园区   checkStatus = 0
                        2填写店铺及服务商资料 checkStatus = 0
                        3.1/3.2/3.3 等待审核  checkStatus = 1(包括审核通过 checkStatus = 10、审核驳回 checkStatus = 2)
                        4提交审核   checkStatus = 10 && ystRegisterStep = 0
                        5认证公司信息 checkStatus = 10 && ystRegisterStep = 1
                        6签约电子协议   checkStatus = 10 && ystRegisterStep = 2
                        7系统处理其他认证信息 checkStatus = 10 && ystRegisterStep = 3
                        8云商通注册成功']; checkStatus = 10 && ystRegisterStep = 10
                        checkStatus:0(未提交审核)1(待审核)2(审核驳回)10(审核通过)
                        ystRegisterStep  云商通认证步骤:0(未认证)1(已注册并提交公司信息)2(已认证公司信息，待签电子协议)3(已完成电子协议签约，待处理其他认证)10(已完成服务商注册)
                        if(userInfo.newFlag == 1){ //若NewFlag=1，则说明是新注册用且还没完成审核； 


                        // 老用户均是跳转到index，存储当前的步骤
                        // 新用户 跳转到 registerInfo，存储当前步骤
                        从消息可以跳转到审核通过的界面
                    */
                   if(userInfo.newFlag != 1) vm.$router.replace({name: 'index'});
                    if(userInfo.checkStatus == 0){ //1选择入住园区 2填写店铺及服务商资料
                        vm.thisStep = 0; vm.active = 1;
                    }else if(userInfo.checkStatus == 1 || userInfo.checkStatus == 2){//3.1等待审核 /3.3审核驳回
                        vm.thisStep = userInfo.checkStatus == 1 ? 3.1 : 3.3;
                        vm.active = 3;
                    }else if(userInfo.checkStatus == 10){//审核通过
                        if(userInfo.ystRegisterStep == 0){ //4提交审核
                            vm.thisStep = 4;
                            vm.active = 1;
                        }else if(userInfo.ystRegisterStep == 1){ //5认证公司信息
                            vm.thisStep = 5;
                            vm.active = 2;
                        }else if(userInfo.ystRegisterStep == 2){ //6签约电子协议
                            vm.thisStep = 6;
                            vm.active = 3;
                        }else if(userInfo.ystRegisterStep == 3){ //7系统处理其他认证信息
                            vm.thisStep = 7;
                            vm.active = 4;
                        }else if(userInfo.ystRegisterStep == 10){ //8云商通注册成功
                            vm.thisStep = 8;
                            vm.active = 5;
                        }
                    }
                    // 存储必须信息
                    access.session('checkStatusC', vm.checkStatus[String(userInfo.checkStatus)]); //审核状态名称
                    access.session('checkStatus', userInfo.checkStatus); //审核状态
                    access.session('companyName', userInfo.companyName); //公司名称
                    access.session('ystRegisterStep', userInfo.ystRegisterStep); 
                    access.session('newFlag', userInfo.newFlag); //是否为新用户
                    vm.$refs.headers.refrashStatus();
                    // 默认园区
                    if(res.data.parkList && userInfo.parkList.length > 0){
                        access.session('projectId', userInfo.parkList[0].parkId);
                        access.session('projectName', userInfo.parkList[0].parkName);
                        for(let i = 0; i < userInfo.parkList.length; i++){
                            vm.chooseIds.push(userInfo.parkList[i].parkId);
                            /* vm.parkList.push({
                                id: userInfo.parkList[i].parkId,
                                projectName: userInfo.parkList[i].parkName,

                            }) */
                        }
                    } 
                    vm.checkRemark = userInfo.checkRemark;
                    return;
                }
                vm.$showAlert(res.message || res.error ||  '查询初始信息失败，请刷新重试', 'error');
            }).catch((res)=>{
                vm.$showAlert(res.message || res.error ||  '查询初始信息失败，请刷新重试', 'error')
            })
        },
        toggleShow() {    
            this.collapsed = !this.collapsed;
        },
        showMail(){
            this.isMail = true;
        },
        hideMail(){
            this.isMail = false;
        },
        changeProject(parkList){
            this.parkList = parkList;
            this.setChoose(parkList);
        },
        setChoose(arr){
            let vm = this, chooseIds = [];
            arr.forEach(item=>{
                chooseIds.push(item.id);
            })
            vm.chooseIds = chooseIds;
        },
        jump(list){
            let vm = this;
            vm.$router.replace({
                name: vm.$route.name,
                query: {
                    active: vm.active,
                    steps: vm.thisStep,
                    list: list ? JSON.stringify(list) : ''
                }
            })
        },
        // 上一步
        prevStep(){
            let vm = this;
            vm.chooseIds = vm.$refs.secondStep.getChooseIds();
            --vm.active;
            vm.jump();
        },
        /* 
            进行下一步
            active = 1,选择完园区，需要到第二步
            active = 2 填写完资料，需要提交资料
        */
        nextStep(data){
            let vm = this;
            if(vm.active == 1){
                vm.toSecondStep();
            }else{
                vm.$refs.secondStep.submitForm(()=>{
                    // 刷新页面
                    vm.active = 3;
                    vm.thisStep = 3.1;
                    vm.$refs.headers.refrashStatus();
                });
            }
        },
        toSecondStep(bool = false){
            let vm = this;
            let list = vm.parkList.map((item)=>{
                return {
                    id: item.id,
                    projectName: item.projectName
                }
            });
            vm.active = 2;
            if(!bool){
                vm.$refs.secondStep.changeProject(vm.parkList);
                vm.$refs.secondStep.getquery(vm.parkList);
            }
            // vm.jump(list);
            vm.jump();
        },
        // 重新编辑
        reEdit(){   
            // 审核退回，需要重新编辑，重置thisStep = 0
            let vm = this;
            vm.thisStep = 0;
            vm.active = 1
            // vm.toSecondStep(true);
        },  
        // 签约电子协议
        signUp(){
            let vm = this;
            vm.$refs.thirdStep.toSign();
        },
        // 发布商品
        toRelease(){
            let vm = this;
            API.http({url: '/merchant/service/start', type: 'post',
                postType: 'urlencoded',
            }).then(res => {
                if(res.code == 200){
                    vm.$router.push({ name:  'esGoodsManage'});
                    return;
                }
                vm.$showAlert(res.message || res.error ||  '操作失败，请重试', 'error');
            }).catch(res => {
                vm.$showAlert(res.message || '操作失败，请重试', 'error');
                return;
            })
            
        }
    }
}
</script>

<style lang="scss">
    .m-registerInfo{
        .el-scrollbar__wrap{
            overflow-x: hidden;
        }
    }
</style>
<style lang="scss" scoped>
@import '../../style/variable';
    .m-registerInfo{
        padding-top: 70px;
        background-color: $c9;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .m-section{
            margin: 20px;
            flex: 1;
            &.bg{
                background-color: $c1;
                padding: 20px 0 20px 20px;
            }
            &.pad-b-40{
                padding-bottom: 40px;
            }
        }
        .foter-btns{
            text-align: center;
            line-height: 80px;
            height: 80px;
            background-color: $c1;
        }
    }
</style>